module.exports = __webpack_public_path__ + "static/media/render-front-view.147ecdf5.png";